import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "links-and-pagination"
    }}>{`Links and Pagination`}</h1>
    <h3 {...{
      "id": "links"
    }}>{`Links`}</h3>
    <p>{`Content returned from the Lightroom APIs often includes a `}<inlineCode parentName="p">{`base`}</inlineCode>{` URL and table of relative `}<inlineCode parentName="p">{`links`}</inlineCode>{` that should be used when assembling subsequent requests. To ensure the most robust future-proofing, clients should avoid cobbling together their own fully formed URLs when possible.`}</p>
    <p>{`For example, the API to retrieve a catalog might return (unique identifiers have been shortened to preserve readability):`}</p>
    <pre><code parentName="pre" {...{}}>{`{
    "base": "https://lr.adobe.io/v2/catalogs/18c23e15/",
    ...
    "links" {
        "self": {
            "href": "/v2/catalogs/18c23e15"
        },
        "/rels/albums": {
            "href": "albums"
        }
    }
}
`}</code></pre>
    <p>{`To construct the API endpoint to enumerate the albums in the catalog, an application should concatenate the `}<inlineCode parentName="p">{`base`}</inlineCode>{` with the `}<inlineCode parentName="p">{`/rels/albums`}</inlineCode>{` value in `}<inlineCode parentName="p">{`href`}</inlineCode>{`. When composing these two elements into a single URL, clients should use the standard rules for URI resolution as defined in section 5.2 of RFC 3986. We strongly recommend that clients use standard library implementations to avoid worrying about corner cases of the RFC URI rules.`}</p>
    <h3 {...{
      "id": "pagination"
    }}>{`Pagination`}</h3>
    <p>{`Indefinitely long lists of content, such as albums and assets, may be paginated during their return. Therefore, a client may need to make multiple calls to enumerate the entire list. The `}<inlineCode parentName="p">{`links`}</inlineCode>{` subsection of returned content will contain a `}<inlineCode parentName="p">{`next`}</inlineCode>{` field that encapsulates the API call for fetching an additional page of assets. Sample recursive JavaScript might be:`}</p>
    <pre><code parentName="pre" {...{}}>{`function getPagedJSONContentP(url) {
    return new Promise(function(resolve, reject) {
        var response = {
            resources: []
        }
        function getPage(url) {
            getJSONContentP(url).then(function(page) {
                response.base = page.base
                response.resources = response.resources.concat(page.resources)
                if (page.links.next) {
                    getPage(page.base + page.links.next.href)
                }
                else {
                    resolve(response)
                }
            }, reject)
        }
        getPage(url)
    })
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      